import z from 'zod'
import { objectToCamel } from 'ts-case-convert'
import { loginMicroSchema, supplierSchema } from './user'

//* ---------------- BASE ------------------- *//
const baseSkuSchema = z.object({
  id: z.number(),
  sku: z.string(),
  supplier_number: z.string(),
  category: z.string(),
  subcategory: z.string(),
  collection: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date().nullable(),
  is_active: z.coerce.boolean(),
  image: z.string().nullable(),
  supplier: supplierSchema.nullable(),
})

const baseInventorySchema = z.object({
  id: z.number(),
  distribution_center_id: z.number(),
  stock_available: z.coerce.number(),
  stock_on_hand: z.coerce.number(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date().nullable(),
  restock_date: z.coerce.date().nullable(),
})

const baseSkuHistorySchema = z.object({
  id: z.number(),
  stock: z.coerce.number().nullable(),
  reason: z.string().nullable(),
  created_at: z.coerce.date(),
  login_id: z.number().nullable(),
  login: loginMicroSchema.nullable(),
})

//* ---------------- SCHEMAS ---------------- *//
export const skuSchema = baseSkuSchema.transform(objectToCamel)

export const inventorySchema = baseInventorySchema.transform(objectToCamel)

export const skuHistorySchema = baseSkuHistorySchema.transform(objectToCamel)

export const extendedSkuSchema = baseSkuSchema
  .extend({
    supplier_id: z.number().nullable(),
    vat_duty_cost_meter: z.coerce.number().nullable(),
    shipping_cost_meter: z.coerce.number().nullable(),
    mill_cost_meter: z.coerce.number().nullable(),
    inventory: z.array(inventorySchema).nullable(),
  })
  .transform(objectToCamel)

//* ---------------- TYPES ------------------ *//
declare global {
  namespace TrinityAPI {
    type SkuType = z.infer<typeof skuSchema>
    type SkuExtendedType = z.infer<typeof extendedSkuSchema>
    type InventoryType = z.infer<typeof inventorySchema>
    type SkuHistoryType = z.infer<typeof skuHistorySchema>
  }
}
